import { render } from "./TextInput.vue?vue&type=template&id=255835f6&scoped=true&ts=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=255835f6&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255835f6"]])

export default __exports__